import { FC, memo, useCallback } from 'react'

import { Divider, AttentionCircleIcon, Text } from '@cash-me/react-components'
import NextLink from 'next/link'

import { Grid, Col } from 'components/grid'
import { Logo } from 'components/logo'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

const Footer: FC = memo(() => {
  const handleDataLayer = useCallback((name: string) => {
    pushDataLayer({
      category: 'Clique',
      action: 'Footer',
      label: `Link ${name}`
    })
  }, [])

  return (
    <S.Wrapper>
      <Grid col={{ phone: 1, tablet: 1, desktop: 12 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <S.LogoWrapper>
            <Logo type="CashmeFooter" width={9.375} height={2} />
            <S.Address>
              <Text size="body2" color="var(--colors-blue-text-strong)">
                Rua Olimpíadas, 242, 7º andar - Vila Olímpia São Paulo - São Paulo | CEP 04551-000
              </Text>
            </S.Address>
            <S.Social>
              <Text size="body2" color="var(--colors-blue-text-strong)">
                Acompanhe
              </Text>
              <a
                href="https://www.facebook.com/CashMeBrasil/"
                target="_blank"
                onClick={() => handleDataLayer('Facebook')}
                rel="nofollow noreferrer"
                title="Facebook"
              >
                <Logo type="IconFacebook" width={1.625} height={1.563} ariaLabel="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/cashmebrasil/"
                target="_blank"
                onClick={() => handleDataLayer('Instagram')}
                rel="nofollow noreferrer"
                title="Instagram"
              >
                <Logo type="IconInstagram" width={1.625} height={1.563} ariaLabel="Instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/cashmebrasil/mycompany/"
                target="_blank"
                onClick={() => handleDataLayer('LinkedIn')}
                rel="nofollow noreferrer"
                title="LinkedIn"
              >
                <Logo type="IconLinkedin" width={1.25} height={1.25} ariaLabel="LinkedIn" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCeuoZPiBsF4QyR9kqVpaBog"
                target="_blank"
                onClick={() => handleDataLayer('YouTube')}
                rel="nofollow noreferrer"
                title="YouTube"
              >
                <Logo type="IconYoutube" width={1.625} height={1.563} ariaLabel="YouTube" />
              </a>
            </S.Social>
          </S.LogoWrapper>
          <Divider css={{ margin: '1.5rem 0', backgroundColor: '#555B66' }} />
          <S.SafetyLinksWrapper>
            <NextLink
              href="/aviso-de-privacidade"
              onClick={() => handleDataLayer('Política de Privacidade')}
              className="ds-link"
            >
              Política de privacidade
            </NextLink>
            <S.Circle />
            <NextLink
              rel="nofollow"
              href="https://contatoseguro.com.br/cashme/"
              onClick={() => handleDataLayer('Canal de Denúncias')}
              className="ds-link"
            >
              Canal de Denúncias
            </NextLink>
          </S.SafetyLinksWrapper>
          <Divider css={{ margin: '1.5rem 0', backgroundColor: '#555B66' }} />
          <S.WarningWrapper>
            <AttentionCircleIcon size={18} color="var(--colors-primary-icon-strong)" />
            <S.Warning size="caption" weight="medium" color="var(--colors-neutral-text-contrast-default)">
              Não solicitamos nenhum tipo de depósito ou pagamento antecipado para aprovação da operação de empréstimo.
              Por razões de segurança, não enviamos e-mails com extensões (@gmail, @yahoo, @hotmail, etc.) que não sejam
              @cashme.com.br.
            </S.Warning>
          </S.WarningWrapper>
          <Divider css={{ margin: '1.5rem 0', backgroundColor: '#555B66' }} />
          <S.LegalInfoWrapper>
            <Text size="caption" weight="medium" color="var(--colors-neutral-background-pressed)">
              A CashMe não realiza qualquer atividade privativa de instituições financeiras, como financiamentos e/ou
              empréstimos direto a seus clientes. Nos termos da Resolução nº 4.935, de 29 de julho de 2021, do Conselho
              Monetário Nacional, a CashMe atua meramente como Correspondente Bancário de instituições financeiras, as
              quais, na qualidade de agentes bancarizadores devidamente autorizados pelo Banco Central do Brasil,
              figuram como credores em favor de terceiros em operações de crédito e empréstimos. As instituições
              financeiras com as quais atuamos são: BMP Sociedade de Crédito Direto S/A e OXY Companhia Hipotecária.
            </Text>
            <Text size="caption" weight="medium" color="var(--colors-neutral-background-pressed)">
              CASHME SOLUÇÕES FINANCEIRAS S.A., possui sede social na capital do estado de SP, à Rua Olimpíadas, 242, 7º
              andar, CEP 04551-000, na cidade de São Paulo/SP, inscrita no CNPJ sob o no 34.175.529/0001-68.
            </Text>
          </S.LegalInfoWrapper>
        </Col>
      </Grid>
    </S.Wrapper>
  )
})

Footer.displayName = 'Footer'

export default Footer
